var _excluded = ["className", "variant", "icon", "iconClass", "label", "message", "children", "small", "medium", "large", "xlarge"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import PropTypes from "prop-types";
import React, { forwardRef } from "react";
import AIcon from "../AIcon";
import "./AEmptyState.scss";
var AEmptyState = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var propsClassName = _ref.className,
    variant = _ref.variant,
    propsIcon = _ref.icon,
    propsIconClass = _ref.iconClass,
    label = _ref.label,
    message = _ref.message,
    children = _ref.children,
    small = _ref.small,
    medium = _ref.medium,
    large = _ref.large,
    xlarge = _ref.xlarge,
    rest = _objectWithoutProperties(_ref, _excluded);
  var baseClass = "a-empty-state",
    backgroundClass = "".concat(baseClass, "__background"),
    labelClass = "".concat(baseClass, "__label"),
    messageClass = "".concat(baseClass, "__message");
  var className = baseClass,
    iconClass = "".concat(baseClass, "__icon"),
    containerClass = "".concat(baseClass, "__container"),
    icon = propsIcon;
  if (propsClassName) {
    className += " ".concat(propsClassName);
  }
  if (variant === "success") {
    className += " ".concat(baseClass, "--state-success");
    icon = "positive";
  } else if (variant === "warning") {
    className += " ".concat(baseClass, "--state-warning");
    icon = "warning";
  } else if (variant === "danger") {
    className += " ".concat(baseClass, "--state-danger");
    icon = "negative";
  } else if (!propsIcon) {
    className += " ".concat(baseClass, "--state-info");
    icon = "info";
  }
  if (small) {
    className += " ".concat(baseClass, "--small");
  } else if (medium) {
    className += " ".concat(baseClass, "--medium");
  } else if (large) {
    className += " ".concat(baseClass, "--large");
  } else if (xlarge) {
    className += " ".concat(baseClass, "--xlarge");
  } else {
    className += " ".concat(baseClass, "--medium");
  }
  return /*#__PURE__*/React.createElement("div", _extends({}, rest, {
    ref: ref,
    className: className
  }), /*#__PURE__*/React.createElement("div", {
    className: containerClass
  }, /*#__PURE__*/React.createElement(AIcon, {
    className: backgroundClass
  }, "empty-background"), /*#__PURE__*/React.createElement(AIcon, {
    className: iconClass
  }, propsIcon || icon)), label && /*#__PURE__*/React.createElement("div", {
    className: labelClass
  }, label), message && /*#__PURE__*/React.createElement("div", {
    className: messageClass
  }, message), children);
});
AEmptyState.defaultProps = {
  variant: "info"
};
AEmptyState.propTypes = {
  /**
   * Empty state variant
   */
  variant: PropTypes.oneOf(["success", "positive", "warning", "danger"]),
  /**
   * Custom icn name
   */
  icon: PropTypes.string,
  /**
   * Class name for the icon
   */
  iconClass: PropTypes.string,
  /**
   * Label for the empty state
   */
  label: PropTypes.string,
  /**
   * Message describing the empty state
   */
  message: PropTypes.string,
  /**
   * Sets the container size to small.
   */
  small: PropTypes.bool,
  /**
   * Sets the container size to medium.
   */
  medium: PropTypes.bool,
  /**
   * Sets the container size to large.
   */
  large: PropTypes.bool,
  /**
   * Sets the container size to extra large.
   */
  xlarge: PropTypes.bool,
  /** Node children */
  children: PropTypes.node
};
AEmptyState.displayName = "AEmptyState";
export default AEmptyState;